import { mapGetters } from "vuex";
import {status_list, emp_status_list, other_give_out} from '@/views/fin/salaryadministration/fields.js'
import { VBtn, VExpansionPanels, VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent } from 'vuetify/lib'
import SearchBar from '@/vuetify_custom/v-form'
import styles from '../index.module.less'
export default {
    props: {
        value: {
            type:Object,
            default:() => ({})
        },
        employeeTypeList: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            params: this.value,
            expand: null,
        }
    },

    watch: {
        value(val) {
            this.params = val
        },
        params(val) {
            this.$emit('input', val)
        }
    },
    computed: {
        ...mapGetters('async', ['root_teams']),
        searchFields() {
            return [
                    {
                        type: 'select_field',
                        key: 'team_id',
                        label:'所属团队',
                        'item-text': 'name',
                        'item-value': 'id',
                        cols: 3,
                        clearable: true,
                        'hide-details': true,
                        items: [
                            {name:'全部团队', id:'all'},
                             ...this.root_teams.filter(item => !item.del)]
                    }, 
                    {
                        type: 'select_field',
                        key: 'emp_status',
                        label:'状态',
                        'item-text': 'value',
                        'item-value': 'value',
                        cols: 3,
                        clearable: true,
                        'hide-details': true,
                        items: emp_status_list.map(v => ({
                            value:v
                        }))
                    },
                    {
                        type: 'select_field',
                        key: 'status_flag',
                        label:'本期特殊人员',
                        'item-text': 'title',
                        'item-value': 'value',
                        cols: 3,
                        clearable: true,
                        'hide-details': true,
                        items: status_list
                    },
                    {
                        type: 'select_field',
                        key: 'has_other_subsidy',
                        label:'是否有其他发放',
                        'item-text': 'title',
                        'item-value': 'value',
                        cols: 3,
                        clearable: true,
                        'hide-details': true,
                        items: other_give_out
                    },
                    {
                        label: '姓名',
                        key:'name',
                        cols: 3,
                    },
                    {
                         cols: 2,
                         key:'action'
                    }
            ]
        }
    },
    render() {
        const _this = this
        return <div class={styles['search-bar-contain']}>
                    <VExpansionPanels flat v-model={this.expand}> 
                                    <VExpansionPanel>
                                        <VExpansionPanelHeader>
                                            筛选条件
                                        </VExpansionPanelHeader>
                                    <VExpansionPanelContent>
                                    <SearchBar 
                                        v-model={this.params}
                                        cols={12}
                                        fields={this.searchFields}
                                        // action
                                        scopedSlots={{
                                            action() {
                                                return <div>
                                                    <VBtn
                                                    color="primary"
                                                    on={{
                                                        click: () => {
                                                            _this.params.cur_page = 1
                                                            _this.$nextTick(() => {
                                                                _this.$emit('search')
                                                            })
                                                        
                                                        }
                                                    }}
                                                    >
                                                        搜索
                                                    </VBtn>
                                                </div>
                                            },
                       
                                        }}
                                    />
                                    </VExpansionPanelContent>
                                </VExpansionPanel>
                        </VExpansionPanels>
        </div> 
    }
}